import React from "react";
import DataTable from "./../../partials/table/DataTables.js";
import { Link } from "react-router-dom";
import conf from "./../../../config.js";
import axios from "axios";
import tokenApi from "../../auth/Helpers";
import { Modal, Tabs, Tab } from "react-bootstrap";
import SweetAlert from "sweetalert2-react";
import swal from "sweetalert2";
import Select from "react-select";
import Skeleton from "react-loading-skeleton";

const selectStyles = {
    control: (styles) => ({
        ...styles,
        borderRadius: "100px",
        minWidth: "15rem",
    }),
};

export default class Alumni extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            // URLs
            url_alumni: `${conf.uri_backend}api/v1/user/alumni`,
            url_stats: `${conf.uri_backend}api/v1/user/alumni/stats`,
            url_history: `${conf.uri_backend}api/v1/user/alumni/history`,
            url_eligible: `${conf.uri_backend}api/v1/user/alumni/eligible`,
            url_tambah: `${conf.uri_backend}api/v1/user/alumni/tambah`,
            url_batal: `${conf.uri_backend}api/v1/user/alumni/batal`,

            // Session
            institusi_id_select: "",
            jenjang_id_select: "",
            data_session: [],

            // Stats
            total_alumni: 0,
            stats_per_tahun: [],
            stats_per_kelas: [],
            stats_loading: true,

            // Filters
            query: "",
            tahun_lulus_filter: "",
            kelas_filter: "",
            kurikulum_filter: "",

            // Detail Modal
            modal_detail: false,
            detail_loading: false,
            detail_siswa: null,
            detail_history: [],

            // Tambah Alumni Modal
            modal_tambah: false,
            eligible_data: [],
            eligible_loading: false,
            eligible_query: "",
            selected_eligible: [],
            tambah_loading: false,

            // Alert
            show_alert: false,
            title_alert: "",
            message_alert: "",
            icon_alert: "",

            // Mode show
            mode_show: 10,

            // Active tab
            active_tab: "list",
        };

        this.dataTable = React.createRef();
        this.eligibleTable = React.createRef();
    }

    componentDidMount() {
        if (localStorage.getItem("token") !== null) {
            axios
                .post(`${conf.uri_backend}api/v1/auth/sso/user`, {
                    token: localStorage.getItem("token"),
                })
                .then((res) => {
                    this.setState({
                        data_session: res.data,
                    });

                    axios
                        .get(
                            `${conf.uri_backend}api/v1/select-institusi/` +
                            res.data.access_to,
                            { headers: { Authorization: tokenApi } }
                        )
                        .then((res2) => {
                            this.setState(
                                {
                                    institusi_id_select: res2.data.id,
                                    jenjang_id_select: res2.data.m_struktur_jenjang_id,
                                },
                                () => {
                                    this.loadStats();
                                    // Trigger initial DataTable load
                                    setTimeout(() => {
                                        if (this.dataTable.current) {
                                            this.dataTable.current.resetPage(this.buildQuery());
                                        }
                                    }, 100);
                                }
                            );
                        });
                });
        }
    }

    loadStats() {
        this.setState({ stats_loading: true });
        axios
            .get(
                `${this.state.url_stats}?institusi_id=${this.state.institusi_id_select}`,
                { headers: { Authorization: tokenApi } }
            )
            .then((res) => {
                if (res.data.status) {
                    this.setState({
                        total_alumni: res.data.total_alumni,
                        stats_per_tahun: res.data.per_tahun || [],
                        stats_per_kelas: res.data.per_kelas || [],
                        stats_loading: false,
                    });
                }
            })
            .catch(() => {
                this.setState({ stats_loading: false });
            });
    }

    // ============ SEARCH & FILTER ============

    buildQuery() {
        let qry = `&institusi_id=${this.state.institusi_id_select}`;
        if (this.state.query) qry += `&query=${this.state.query}`;
        if (this.state.tahun_lulus_filter)
            qry += `&tahun_lulus=${this.state.tahun_lulus_filter}`;
        if (this.state.kelas_filter) qry += `&kelas=${this.state.kelas_filter}`;
        if (this.state.kurikulum_filter)
            qry += `&kurikulum=${this.state.kurikulum_filter}`;
        return qry;
    }

    searchText(e) {
        e.preventDefault();
        this.setState({ query: e.target.value }, () => {
            if (this.dataTable.current) {
                this.dataTable.current.resetPageDebounced(this.buildQuery());
            }
        });
    }

    applyFilter() {
        if (this.dataTable.current) {
            this.dataTable.current.resetPage(this.buildQuery());
        }
    }

    resetFilter() {
        this.setState(
            {
                query: "",
                tahun_lulus_filter: "",
                kelas_filter: "",
                kurikulum_filter: "",
            },
            () => {
                this.applyFilter();
            }
        );
    }

    // ============ DETAIL MODAL ============

    showDetail(data) {
        this.setState({ modal_detail: true, detail_loading: true });
        axios
            .get(
                `${this.state.url_history}?user_siswa_id=${data.user_siswa_id}`,
                { headers: { Authorization: tokenApi } }
            )
            .then((res) => {
                if (res.data.status) {
                    this.setState({
                        detail_siswa: res.data.siswa,
                        detail_history: res.data.history,
                        detail_loading: false,
                    });
                }
            })
            .catch(() => {
                this.setState({ detail_loading: false });
            });
    }

    // ============ BATAL ALUMNI ============

    batalAlumni(data) {
        swal
            .fire({
                title: "Batalkan Status Alumni?",
                html: `<p>Siswa <b>${data.nama}</b> akan dikembalikan ke status aktif di rombel <b>${data.nama_rombel}</b>.</p>`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#e53e3e",
                cancelButtonColor: "#a0aec0",
                confirmButtonText: "Ya, Batalkan",
                cancelButtonText: "Tidak",
            })
            .then((result) => {
                if (result.isConfirmed) {
                    axios
                        .post(
                            this.state.url_batal,
                            { rombel_siswa_id: data.id },
                            { headers: { Authorization: tokenApi } }
                        )
                        .then((res) => {
                            if (res.data.status) {
                                this.setState({
                                    show_alert: true,
                                    title_alert: "Berhasil",
                                    message_alert: res.data.messages[0],
                                    icon_alert: "success",
                                });
                                if (this.dataTable.current) {
                                    this.dataTable.current.resetPage(this.buildQuery());
                                }
                                this.loadStats();
                            }
                        })
                        .catch((err) => {
                            this.setState({
                                show_alert: true,
                                title_alert: "Gagal",
                                message_alert:
                                    err.response?.data?.messages?.[0] || "Terjadi kesalahan",
                                icon_alert: "error",
                            });
                        });
                }
            });
    }

    // ============ TAMBAH ALUMNI ============

    loadEligible(search = "") {
        this.setState({ eligible_loading: true });
        const url = `${this.state.url_eligible}?institusi_id=${this.state.institusi_id_select}&per_page=50${search ? `&query=${search}` : ""}`;
        axios
            .get(url, { headers: { Authorization: tokenApi } })
            .then((res) => {
                this.setState({
                    eligible_data: res.data.data || [],
                    eligible_loading: false,
                });
            })
            .catch(() => {
                this.setState({ eligible_loading: false });
            });
    }

    openTambahModal() {
        this.setState(
            {
                modal_tambah: true,
                selected_eligible: [],
                eligible_query: "",
            },
            () => {
                this.loadEligible();
            }
        );
    }

    toggleEligible(item) {
        const { selected_eligible } = this.state;
        const exists = selected_eligible.find((s) => s.id === item.id);
        if (exists) {
            this.setState({
                selected_eligible: selected_eligible.filter((s) => s.id !== item.id),
            });
        } else {
            this.setState({
                selected_eligible: [...selected_eligible, item],
            });
        }
    }

    selectAllEligible() {
        const { eligible_data, selected_eligible } = this.state;
        const allIds = eligible_data.map((d) => d.id);
        const allSelected = allIds.every((id) =>
            selected_eligible.find((s) => s.id === id)
        );
        if (allSelected) {
            this.setState({
                selected_eligible: selected_eligible.filter(
                    (s) => !allIds.includes(s.id)
                ),
            });
        } else {
            const newSelected = [...selected_eligible];
            eligible_data.forEach((d) => {
                if (!newSelected.find((s) => s.id === d.id)) {
                    newSelected.push(d);
                }
            });
            this.setState({ selected_eligible: newSelected });
        }
    }

    submitTambahAlumni() {
        const { selected_eligible } = this.state;
        if (selected_eligible.length === 0) {
            this.setState({
                show_alert: true,
                title_alert: "Peringatan",
                message_alert: "Pilih minimal satu siswa",
                icon_alert: "warning",
            });
            return;
        }

        swal
            .fire({
                title: "Tambah Alumni?",
                html: `<p><b>${selected_eligible.length}</b> siswa akan ditambahkan sebagai alumni.</p>`,
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: "#3182ce",
                cancelButtonColor: "#a0aec0",
                confirmButtonText: "Ya, Tambahkan",
                cancelButtonText: "Batal",
            })
            .then((result) => {
                if (result.isConfirmed) {
                    this.setState({ tambah_loading: true });
                    axios
                        .post(
                            this.state.url_tambah,
                            {
                                rombel_siswa_ids: selected_eligible.map((s) => s.id),
                            },
                            { headers: { Authorization: tokenApi } }
                        )
                        .then((res) => {
                            if (res.data.status) {
                                this.setState({
                                    show_alert: true,
                                    title_alert: "Berhasil",
                                    message_alert: res.data.messages[0],
                                    icon_alert: "success",
                                    modal_tambah: false,
                                    tambah_loading: false,
                                    selected_eligible: [],
                                });
                                if (this.dataTable.current) {
                                    this.dataTable.current.resetPage(this.buildQuery());
                                }
                                this.loadStats();
                            }
                        })
                        .catch((err) => {
                            this.setState({
                                show_alert: true,
                                title_alert: "Gagal",
                                message_alert:
                                    err.response?.data?.messages?.[0] || "Terjadi kesalahan",
                                icon_alert: "error",
                                tambah_loading: false,
                            });
                        });
                }
            });
    }

    // ============ DATA TABLE COLUMNS ============

    showData() {
        let columns = [
            { index: "no", label: "No" },
            { index: "nama", label: "Nama" },
            { index: "nisn", label: "NISN" },
            { index: "kode_pendaftaran", label: "Kode Pendaftaran" },
            { index: "jenis_kelamin", label: "JK" },
            { index: "kelas", label: "Kelas" },
            { index: "nama_rombel", label: "Rombel Terakhir" },
            { index: "tahun_lulus", label: "Tahun Lulus" },
            { index: "aksi", label: "Aksi" },
        ];

        let action = {
            no: (col, data, index) => {
                return (
                    <span className="text-gray-700 py-2 flex items-center text-sm">
                        {index + 1}
                    </span>
                );
            },
            jenis_kelamin: (col, data) => {
                return (
                    <span className="text-gray-700 py-2 flex items-center text-sm">
                        <span
                            className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${data.jenis_kelamin === "L" || data.jenis_kelamin === "Laki-laki"
                                ? "bg-blue-100 text-blue-800"
                                : "bg-pink-100 text-pink-800"
                                }`}
                        >
                            {data.jenis_kelamin === "L" || data.jenis_kelamin === "Laki-laki"
                                ? "L"
                                : "P"}
                        </span>
                    </span>
                );
            },
            tahun_lulus: (col, data) => {
                return (
                    <span className="text-gray-700 py-2 flex items-center text-sm">
                        <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                            <i className="bx bxs-graduation mr-1"></i>
                            {data.tahun_lulus || "-"}
                        </span>
                    </span>
                );
            },
            aksi: (col, data) => {
                return (
                    <div className="flex items-center gap-1 py-1">
                        <button
                            onClick={() => this.showDetail(data)}
                            className="alumni-btn-detail"
                            title="Lihat Detail & Riwayat"
                        >
                            <i className="bx bx-history text-base"></i>
                        </button>
                        <button
                            onClick={() => this.batalAlumni(data)}
                            className="alumni-btn-batal"
                            title="Batalkan Alumni"
                        >
                            <i className="bx bx-undo text-base"></i>
                        </button>
                    </div>
                );
            },
        };

        return { columns, action };
    }

    // ============ RENDER SECTIONS ============

    renderStatsCards() {
        const { stats_loading, total_alumni, stats_per_tahun, stats_per_kelas } =
            this.state;

        if (stats_loading) {
            return (
                <div className="alumni-stats-grid">
                    {[1, 2, 3].map((i) => (
                        <div key={i} className="alumni-stat-card">
                            <Skeleton height={60} />
                        </div>
                    ))}
                </div>
            );
        }

        const latestYear =
            stats_per_tahun.length > 0 ? stats_per_tahun[0] : null;

        return (
            <div className="alumni-stats-grid">
                <div className="alumni-stat-card alumni-stat-total">
                    <div className="alumni-stat-icon">
                        <i className="bx bxs-graduation"></i>
                    </div>
                    <div className="alumni-stat-info">
                        <span className="alumni-stat-value">{total_alumni}</span>
                        <span className="alumni-stat-label">Total Alumni</span>
                    </div>
                </div>
                <div className="alumni-stat-card alumni-stat-year">
                    <div className="alumni-stat-icon">
                        <i className="bx bxs-calendar-check"></i>
                    </div>
                    <div className="alumni-stat-info">
                        <span className="alumni-stat-value">
                            {latestYear ? latestYear.total : 0}
                        </span>
                        <span className="alumni-stat-label">
                            {latestYear ? `Lulus ${latestYear.tahun_lulus}` : "Tahun Ini"}
                        </span>
                    </div>
                </div>
                <div className="alumni-stat-card alumni-stat-class">
                    <div className="alumni-stat-icon">
                        <i className="bx bxs-school"></i>
                    </div>
                    <div className="alumni-stat-info">
                        <span className="alumni-stat-value">
                            {stats_per_kelas.length > 0
                                ? stats_per_kelas.map((k) => k.kelas).join(", ")
                                : "-"}
                        </span>
                        <span className="alumni-stat-label">Kelas Terakhir</span>
                    </div>
                </div>
            </div>
        );
    }

    renderDetailModal() {
        const { modal_detail, detail_loading, detail_siswa, detail_history } =
            this.state;

        return (
            <Modal
                show={modal_detail}
                onHide={() => this.setState({ modal_detail: false })}
                size="lg"
                centered
                className="alumni-modal"
            >
                <div className="alumni-modal-content">
                    <div className="alumni-modal-header">
                        <div className="alumni-modal-header-content">
                            <i className="bx bxs-graduation alumni-modal-icon"></i>
                            <h3>Riwayat Rombel Siswa</h3>
                        </div>
                        <button
                            className="alumni-modal-close"
                            onClick={() => this.setState({ modal_detail: false })}
                        >
                            <i className="bx bx-x"></i>
                        </button>
                    </div>

                    <div className="alumni-modal-body">
                        {detail_loading ? (
                            <div className="alumni-detail-loading">
                                <Skeleton height={40} count={3} className="mb-3" />
                                <Skeleton height={80} count={3} className="mb-3" />
                            </div>
                        ) : detail_siswa ? (
                            <>
                                {/* Student Info Card */}
                                <div className="alumni-student-card">
                                    <div className="alumni-student-avatar">
                                        <i className="bx bxs-user-circle"></i>
                                    </div>
                                    <div className="alumni-student-info">
                                        <h4>{detail_siswa.nama}</h4>
                                        <div className="alumni-student-meta">
                                            <span>
                                                <i className="bx bx-id-card"></i> NISN:{" "}
                                                {detail_siswa.nisn || "-"}
                                            </span>
                                            <span>
                                                <i className="bx bx-hash"></i> Kode:{" "}
                                                {detail_siswa.kode_pendaftaran || "-"}
                                            </span>
                                            <span>
                                                <i className="bx bx-user"></i>{" "}
                                                {detail_siswa.jenis_kelamin === "L" ||
                                                    detail_siswa.jenis_kelamin === "Laki-laki"
                                                    ? "Laki-laki"
                                                    : "Perempuan"}
                                            </span>
                                            {detail_siswa.tanggal_lahir && (
                                                <span>
                                                    <i className="bx bx-cake"></i>{" "}
                                                    {detail_siswa.tanggal_lahir}
                                                </span>
                                            )}
                                            {detail_siswa.email && (
                                                <span>
                                                    <i className="bx bx-envelope"></i>{" "}
                                                    {detail_siswa.email}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* Timeline */}
                                <div className="alumni-timeline">
                                    <h5 className="alumni-timeline-title">
                                        <i className="bx bx-time-five"></i> Riwayat Kelas
                                    </h5>
                                    {detail_history.length > 0 ? (
                                        <div className="alumni-timeline-list">
                                            {detail_history.map((item, idx) => (
                                                <div
                                                    key={idx}
                                                    className={`alumni-timeline-item ${item.is_alumni ? "alumni-timeline-graduated" : ""
                                                        }`}
                                                >
                                                    <div className="alumni-timeline-dot">
                                                        {item.is_alumni ? (
                                                            <i className="bx bxs-graduation"></i>
                                                        ) : (
                                                            <span>{idx + 1}</span>
                                                        )}
                                                    </div>
                                                    <div className="alumni-timeline-card">
                                                        <div className="alumni-timeline-card-header">
                                                            <span className="alumni-timeline-kelas">
                                                                Kelas {item.kelas}
                                                            </span>
                                                            <span className="alumni-timeline-ta">
                                                                TA {item.tahun_ajaran}
                                                            </span>
                                                        </div>
                                                        <div className="alumni-timeline-card-body">
                                                            <span>
                                                                <i className="bx bx-group"></i>{" "}
                                                                {item.nama_rombel}
                                                            </span>
                                                            {item.peminatan && (
                                                                <span>
                                                                    <i className="bx bx-book-open"></i>{" "}
                                                                    {item.peminatan}
                                                                </span>
                                                            )}
                                                            {item.wali_kelas && (
                                                                <span>
                                                                    <i className="bx bx-user-check"></i> Wali:{" "}
                                                                    {item.wali_kelas}
                                                                </span>
                                                            )}
                                                            {item.kurikulum && (
                                                                <span>
                                                                    <i className="bx bx-book-reader"></i>{" "}
                                                                    {item.kurikulum === "k13"
                                                                        ? "K13"
                                                                        : item.kurikulum === "merdeka"
                                                                            ? "Merdeka"
                                                                            : item.kurikulum}
                                                                </span>
                                                            )}
                                                            {item.is_alumni && item.tahun_lulus && (
                                                                <span className="alumni-timeline-lulus">
                                                                    <i className="bx bxs-graduation"></i> Lulus{" "}
                                                                    {item.tahun_lulus}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <p className="text-gray-500 text-sm text-center py-4">
                                            Belum ada riwayat rombel
                                        </p>
                                    )}
                                </div>
                            </>
                        ) : (
                            <p className="text-gray-500 text-center py-4">
                                Data tidak ditemukan
                            </p>
                        )}
                    </div>
                </div>
            </Modal>
        );
    }

    renderTambahModal() {
        const {
            modal_tambah,
            eligible_data,
            eligible_loading,
            eligible_query,
            selected_eligible,
            tambah_loading,
        } = this.state;

        return (
            <Modal
                show={modal_tambah}
                onHide={() => this.setState({ modal_tambah: false })}
                size="lg"
                centered
                className="alumni-modal"
            >
                <div className="alumni-modal-content">
                    <div className="alumni-modal-header alumni-modal-header-tambah">
                        <div className="alumni-modal-header-content">
                            <i className="bx bx-user-plus alumni-modal-icon"></i>
                            <h3>Tambah Alumni</h3>
                        </div>
                        <button
                            className="alumni-modal-close"
                            onClick={() => this.setState({ modal_tambah: false })}
                        >
                            <i className="bx bx-x"></i>
                        </button>
                    </div>

                    <div className="alumni-modal-body">
                        <p className="alumni-tambah-desc">
                            <i className="bx bx-info-circle"></i> Pilih siswa tingkat akhir
                            (TK B/VI/IX/XII/XIII) untuk ditambahkan sebagai alumni.
                        </p>

                        {/* Search */}
                        <div className="alumni-tambah-search">
                            <div className="alumni-search-input-wrap">
                                <i className="bx bx-search"></i>
                                <input
                                    type="text"
                                    placeholder="Cari nama, NISN, atau kode pendaftaran..."
                                    value={eligible_query}
                                    onChange={(e) => {
                                        this.setState({ eligible_query: e.target.value });
                                        clearTimeout(this._eligibleTimer);
                                        this._eligibleTimer = setTimeout(() => {
                                            this.loadEligible(this.state.eligible_query);
                                        }, 400);
                                    }}
                                />
                            </div>
                        </div>

                        {/* Selected Count */}
                        {selected_eligible.length > 0 && (
                            <div className="alumni-selected-count">
                                <i className="bx bx-check-circle"></i>
                                <span>{selected_eligible.length} siswa dipilih</span>
                            </div>
                        )}

                        {/* List */}
                        <div className="alumni-eligible-list">
                            {eligible_loading ? (
                                <div className="p-4">
                                    <Skeleton height={50} count={5} className="mb-2" />
                                </div>
                            ) : eligible_data.length > 0 ? (
                                <>
                                    <div className="alumni-eligible-header">
                                        <label className="alumni-checkbox-wrap">
                                            <input
                                                type="checkbox"
                                                checked={
                                                    eligible_data.length > 0 &&
                                                    eligible_data.every((d) =>
                                                        selected_eligible.find((s) => s.id === d.id)
                                                    )
                                                }
                                                onChange={() => this.selectAllEligible()}
                                            />
                                            <span className="alumni-checkbox-label">Pilih Semua</span>
                                        </label>
                                    </div>
                                    {eligible_data.map((item, idx) => {
                                        const isSelected = !!selected_eligible.find(
                                            (s) => s.id === item.id
                                        );
                                        return (
                                            <div
                                                key={item.id}
                                                className={`alumni-eligible-item ${isSelected ? "alumni-eligible-selected" : ""
                                                    }`}
                                                onClick={() => this.toggleEligible(item)}
                                            >
                                                <label className="alumni-checkbox-wrap">
                                                    <input
                                                        type="checkbox"
                                                        checked={isSelected}
                                                        onChange={() => this.toggleEligible(item)}
                                                    />
                                                </label>
                                                <div className="alumni-eligible-info">
                                                    <span className="alumni-eligible-name">
                                                        {item.nama}
                                                    </span>
                                                    <div className="alumni-eligible-meta">
                                                        <span>
                                                            <i className="bx bx-id-card"></i>{" "}
                                                            {item.nisn || "-"}
                                                        </span>
                                                        <span>
                                                            <i className="bx bx-group"></i>{" "}
                                                            {item.nama_rombel}
                                                        </span>
                                                        <span>
                                                            <i className="bx bx-layer"></i> Kelas{" "}
                                                            {item.kelas}
                                                        </span>
                                                        <span>
                                                            <i className="bx bx-calendar"></i> TA{" "}
                                                            {item.tahun_ajaran}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </>
                            ) : (
                                <div className="alumni-eligible-empty">
                                    <i className="bx bx-info-circle"></i>
                                    <p>Tidak ada siswa tingkat akhir yang tersedia</p>
                                </div>
                            )}
                        </div>

                        {/* Submit */}
                        <div className="alumni-tambah-actions">
                            <button
                                className="alumni-btn-cancel"
                                onClick={() => this.setState({ modal_tambah: false })}
                            >
                                Batal
                            </button>
                            <button
                                className="alumni-btn-submit"
                                onClick={() => this.submitTambahAlumni()}
                                disabled={tambah_loading || selected_eligible.length === 0}
                            >
                                {tambah_loading ? (
                                    <>
                                        <i className="bx bx-loader-alt bx-spin"></i> Memproses...
                                    </>
                                ) : (
                                    <>
                                        <i className="bx bxs-graduation"></i> Tambahkan{" "}
                                        {selected_eligible.length > 0
                                            ? `(${selected_eligible.length})`
                                            : ""}
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }

    // ============ MAIN RENDER ============

    render() {
        const { columns, action } = this.showData();

        return (
            <div className="alumni-page">
                {/* Alert */}
                <SweetAlert
                    show={this.state.show_alert}
                    title={this.state.title_alert}
                    text={this.state.message_alert}
                    type={this.state.icon_alert}
                    onConfirm={() => this.setState({ show_alert: false })}
                    onOutsideClick={() => this.setState({ show_alert: false })}
                />

                {/* Header */}
                <div className="alumni-header">
                    <div className="alumni-header-content">
                        <div className="alumni-header-left">
                            <div className="alumni-header-icon-wrap">
                                <i className="bx bxs-graduation"></i>
                            </div>
                            <div>
                                <h1 className="alumni-header-title">Alumni</h1>
                                <p className="alumni-header-subtitle">
                                    Kelola data siswa yang telah lulus
                                </p>
                            </div>
                        </div>
                        <button
                            className="alumni-btn-tambah"
                            onClick={() => this.openTambahModal()}
                        >
                            <i className="bx bx-user-plus"></i>
                            <span>Tambah Alumni</span>
                        </button>
                    </div>
                </div>

                {/* Stats */}
                {this.renderStatsCards()}

                {/* Search & Filter Bar */}
                <div className="alumni-toolbar">
                    <div className="alumni-search-wrap">
                        <i className="bx bx-search alumni-search-icon"></i>
                        <input
                            type="text"
                            className="alumni-search-input"
                            placeholder="Cari nama, NISN, atau kode pendaftaran..."
                            value={this.state.query}
                            onChange={(e) => this.searchText(e)}
                        />
                    </div>
                    <div className="alumni-filter-wrap">
                        <select
                            className="alumni-filter-select"
                            value={this.state.kelas_filter}
                            onChange={(e) =>
                                this.setState({ kelas_filter: e.target.value }, () =>
                                    this.applyFilter()
                                )
                            }
                        >
                            <option value="">Semua Kelas</option>
                            <option value="TK B">TK B</option>
                            <option value="VI">VI</option>
                            <option value="IX">IX</option>
                            <option value="XII">XII</option>
                            <option value="XIII">XIII</option>
                        </select>
                        <select
                            className="alumni-filter-select"
                            value={this.state.kurikulum_filter}
                            onChange={(e) =>
                                this.setState({ kurikulum_filter: e.target.value }, () =>
                                    this.applyFilter()
                                )
                            }
                        >
                            <option value="">Semua Kurikulum</option>
                            <option value="k13">K13</option>
                            <option value="merdeka">Merdeka</option>
                        </select>
                        {(this.state.kelas_filter || this.state.kurikulum_filter || this.state.query) && (
                            <button
                                className="alumni-filter-reset"
                                onClick={() => this.resetFilter()}
                            >
                                <i className="bx bx-x"></i> Reset
                            </button>
                        )}
                    </div>
                </div>

                {/* Data Table */}
                <div className="alumni-table-wrap">
                    {this.state.institusi_id_select && (
                        <DataTable
                            ref={this.dataTable}
                            url={`${this.state.url_alumni}`}
                            columns={columns}
                            action={action}
                        />
                    )}
                </div>

                {/* Modals */}
                {this.renderDetailModal()}
                {this.renderTambahModal()}
            </div>
        );
    }
}
